import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Credit from '../Credit';
import DateFormat from '../DateFormat';

const StyledBoxPublished = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: ${rem('40px')} ${rem('30px')} ${rem('31px')} ${rem('30px')};
  background-color: ${props => props.theme.colors.grayLightest};
  width: 100%;
  ${mediaqueries.lessThan('mobile')`
    padding: ${rem('25px')} ${rem('17px')} ${rem('31px')} ${rem('17px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    align-items: left;
    padding-bottom: ${rem('31px')};
    padding-top: ${rem('45px')};
    margin-bottom:${rem('55px')};
  `};
`;

const TilePublished = styled.div`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('15px')};
  margin-bottom: ${rem('12px')};
`;

const OverwriteDate = styled(DateFormat)`
  font-family: inherit;
  font-size: inherit;
`;

const CreditArticle = styled(Credit)`
  margin-bottom: ${rem('30px')};
`;

const BoxCategories = styled.div`
  display: flex;
  padding-bottom: ${rem('22px')};
  position: relative;
  flex-direction: column;
  &:after {
    background-color: ${props => props.theme.colors.dark};
    content: '';
    height: ${rem('2px')};
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    top: 100%;
    width: ${rem('40px')};
  }
  ${mediaqueries.greaterThan('mobile')`
    flex-direction:row;
    
  `};
  ${mediaqueries.greaterThan('desktop')`
    display:inline-block;
    padding-bottom:0;
    &:after {
      display:none;
    }
  `};
`;

export {
  StyledBoxPublished,
  TilePublished,
  OverwriteDate,
  CreditArticle,
  BoxCategories
};
